import React, { useEffect, useState } from "react";
import "./Signin.css";
import { Button } from "@material-ui/core";
import { signInWithPopup, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { FcGoogle } from "react-icons/fc";
import { auth, provider, firestore } from "../firebase";
import ReCaptcha from "./ReCaptcha";
import CookiesPopup from "./CookiesPopup";
import Main from "../images/main.png";
import Create from "../images/create.png";
import Publish from "../images/publish.png";
import Share from "../images/share.png";

const featureCards = [
  ["Create", Create, "Creating surveys can help gauge the representativeness of individual views and experiences."],
  ["Publish", Publish, "Publishing enables greater control over response data quality instead of every edit going live."],
  ["Share", Share, "This is a unique link bound only to your survey. Share this link to get responses."],
];

function Signin() {
  const navigate = useNavigate();
  const [recaptchaVerified, setRecaptchaVerified] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState("");

  const handleClick = () => {
    if (!recaptchaVerified) {
      setAuthError("Please complete the ReCAPTCHA verification.");
      return;
    }
    setAuthError("");
    setLoading(true);
    signInWithPopup(auth, provider)
      .then((result) => getDoc(doc(firestore, "userprofilemaster", result.user.uid)).then((snapshot) => {
        if (!snapshot.exists()) { navigate("/signup"); return null; }
        const userData = snapshot.data();
        return axios.post("https://user-management-api-v1.onrender.com/api/auth/login", { email: result.user.email, tenantId: userData.tenantId, userRole: userData.roles[0] });
      }))
      .then((response) => {
        if (!response) return;
        Cookies.set("jwtToken", response.data.token, { expires: 1, secure: process.env.NODE_ENV === "production", sameSite: "strict", path: "/" });
        sessionStorage.removeItem("authToken");
        navigate("/");
      })
      .catch((error) => {
        console.error("Error signing in:", error);
        setAuthError("Failed to sign in. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => onAuthStateChanged(auth, (user) => {
    if (!user) return;
    sessionStorage.setItem("email", user.email);
    sessionStorage.setItem("photoURL", user.photoURL || "");
    sessionStorage.setItem("userId", user.uid);
    getDoc(doc(firestore, "userprofilemaster", user.uid)).then((snapshot) => navigate(snapshot.exists() ? "/" : "/signup"));
  }), [navigate]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setShowLoginModal(false);
      }
    };
    if (showLoginModal) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showLoginModal]);

  const openModal = () => {
    setAuthError("");
    setShowLoginModal(true);
  };

  return <>
    <main className="signin-page">
      <section className="signin-shell">
        <div className="signin-topbar">
          <div className="signin-brand">
            <strong>SUREWAY</strong>
            <span>by OmneVu.com</span>
          </div>
          <div className="signin-nav-actions">
            <button
              type="button"
              className="signin-nav-btn signin-nav-btn--ghost"
              onClick={openModal}
            >
              Sign In
            </button>
          </div>
        </div>

        <div className="signin-hero">
          <div className="signin-title">
            <h1>SUREWAY</h1>
            <span />
            <p>Your go to solution for getting<br />responses quickly!</p>
            <div className="signin-hero-actions">
              <button
                type="button"
                className="signin-hero-cta"
                onClick={openModal}
              >
                Get Started
              
              </button>
            </div>
          </div>
          <div className="signin-image-wrap">
            <img className="main-img" src={Main} alt="Exam form illustration" />
          </div>
        </div>

        <div className="signin-features">
          {featureCards.map(([title, image, content]) => (
            <article className="signin-card" key={title}>
              <div className="signin-card-heading">
                <h2>{title}</h2>
                <img className={`signin-feature-image signin-feature-image--${title.toLowerCase()}`} src={image} alt="" />
              </div>
              <p>{content}</p>
              <span className="signin-arrow">→</span>
            </article>
          ))}
        </div>
      </section>
    </main>

    {showLoginModal && (
      <div className="signin-modal-backdrop" onClick={() => setShowLoginModal(false)}>
        <div className="signin-modal" onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            className="signin-modal-close"
            onClick={() => setShowLoginModal(false)}
            aria-label="Close login dialog"
          >
            &times;
          </button>
          <div className="signin-modal-header">
            <div className="signin-modal-brand">
              <strong>SUREWAY</strong>
              <span>by OmneVu.com</span>
            </div>
            <h2 className="signin-modal-title">Welcome to Sureway</h2>
            <p className="signin-modal-subtitle">Sign in to create, manage, and share your surveys</p>
          </div>
          <div className="signin-modal-body">
            <div className="recaptcha-container">
              <ReCaptcha onVerify={(value) => {
                setRecaptchaVerified(Boolean(value));
                if (value) setAuthError("");
              }} />
            </div>
            {authError && <div className="signin-modal-error">{authError}</div>}
            <Button
              onClick={handleClick}
              disabled={loading}
              className="google-login-button"
            >
              <span className="google-mark"><FcGoogle /></span>
              {loading ? "Signing in..." : "Login With Google"}
            </Button>
          </div>
        </div>
      </div>
    )}

    <CookiesPopup />
  </>;
}
export default Signin;
